export const SELECTED_USER_DATA_STATE_KEY = 'selectedUserData';
export const USERS_STATE_KEY = 'users';
